module.exports = "/_next/static/images/348ef9dd640416d4b3f07149fec3cef3-penal-circle.svg.webp";